import React, {
    PureComponent
} from 'react';
import AnimatedView from '../../../../components/componentsGeneral/AnimatedView/AnimatedView';
import ItemDetailContainer from '../../../../components/componentsInventoryManagement/_Lot_Tracking_Components/ItemDetail/ItemDetailContainer';

class invManItemDetailView extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    
    componentDidMount() {

    }

    render() {

        return (
            <AnimatedView>
                <ItemDetailContainer isMobile={this.props.isMobile} warehouseSelection={this.props.warehouseSelection} customerSelection={this.props.customerSelection}/>
            </AnimatedView>

        );
    }
}

export default invManItemDetailView;
